<template>
  <div class="layout">
    <Page></Page>
  </div>
</template>

<script>
import Page from './components/page.vue'
export default {
  name: 'App',
  components: {
    Page,
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  margin: 0;
}
.layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
}
</style>